
export const sparePartApiNm = {
  getSparePartType: "/spare-part/getSparePartType",
  insertSparePartType: "/spare-part/insertSparePartType",
  updateSparePartType: "/spare-part/updateSparePartType",
  deleteSparePartType: "/spare-part/deleteSparePartType",
  getSparePart: "/spare-part/getSparePart",
  getSparePartDetail: "/spare-part/getSparePartDetail",
  insertSparePart: "/spare-part/insertSparePart",
  updateSparePart: "/spare-part/updateSparePart",
  updateSparePartColumn: "/spare-part/updateSparePartColumn",
  deleteSparePart: "/spare-part/deleteSparePart",
  getSparePartTransaction: "/spare-part/getSparePartTransaction",
  getSparePartTransactionDetail: "/spare-part/getSparePartTransactionDetail",
  insertSparePartTransaction: "/spare-part/insertSparePartTransaction",
  updateSparePartTransaction: "/spare-part/updateSparePartTransaction",
  updateSparePartTransactionColumn: "/spare-part/updateSparePartTransactionColumn",
  deleteSparePartTransaction: "/spare-part/deleteSparePartTransaction",
  uploadSparePartFile: "/spare-part/uploadSparePartFile",
  deleteSparePartFile: "/spare-part/deleteSparePartFile",
  uploadSparePartTransactionFile: "/spare-part/uploadSparePartTransactionFile",
  deleteSparePartTransactionFile: "/spare-part/deleteSparePartTransactionFile",
}

export const sparePartColNm = {
  SpTypId: "ประเภท",
  SpTypNm: "ประเภท",
  SpCd: "รหัสอะไหล่",
  SpNm: "ชื่ออะไหล่",
  SpSNm: "ชื่อย่อ",
  Brand: "ยี่ห้อ",
  Model: "รุ่น",
  TrnsDte: "วันที่ทำรายการ",
  Unt: "หน่วย",
  UntPr: "ราคาต่อหน่วย",
  MinStk: "จำนวนขั้นต่ำ",
  CurStk: "คงเหลือ",
  Dscp: "รายละเอียด",
  IsActv: "สถานะ",
  Rmk: "หมายเหตุ",
}

export const sparePartTransactionColNm = {
  TrnsTyp: "ประเภทรายการ",
  TrnsDte: "วันที่ทำรายการ",
  Qty: "จำนวน",
  UntPr: "ราคาต่อหน่วย",
  TotalPr: "ราคารวม",
  TukId: "รถ",
  TlrId: "หางพ่วง",
  SupId: "ผู้จำหน่าย",
  DocNo: "เลขที่เอกสาร",
  DocDte: "วันที่เอกสาร",
  Dscp: "รายละเอียด",
  Rmk: "หมายเหตุ",
}
